import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'node_modules/chart.js';

// env
import { environment } from './../../../../environments/environment';

// Service
import { ApiService } from 'src/app/shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-share-information',
  templateUrl: './share-information.component.html',
  styles: [
  ]
})
export class ShareInformationComponent implements OnInit {

  dataTitle;
  dataSection = [];
  isLang;
  dataChartTotal;
  dataChartDate;
  apiAsset = environment.API_ASSETS;

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // MultiLanguage
   this.isLang =  this.apiService.isLang();

    // Content
    this.apiService.getDataApi('getMenuSection/share-information').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });

    // chart
    this.apiService.getDataApi('getShareholdersComposition').subscribe(response => {
      var label = [];
      var dataset = [];
      response.data.chart.forEach((i,x) => {
          label.push(i.title);
          dataset.push(i.value);
      });

      var oilData = {
        labels: label,
        datasets: [{
          data: dataset,
          backgroundColor: [
            "#7b8ea6",
            "#1b4053",
            "#fe7210"
          ]
        }]
      };

      var myPieChart = new Chart("myChart", {
        type: 'pie',
        data: oilData,
        options: {
          maintainAspectRatio : true,
          responsive : true,
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                return data['labels'][tooltipItem[0]['index']];
              },
              label: function(tooltipItem, data) {
                // return data['datasets'][0]['data'][tooltipItem['index']];
              },
              afterLabel: function(tooltipItem, data) {
                var dataset = data['datasets'][0];
                var percent = (dataset['data'][tooltipItem['index']] / dataset["_meta"][0]?.total) * 100
                return '(' + percent.toFixed(2) + '%)';
              }
            }
          },
          legend: {
              position: 'bottom',
          }
        }
      });   
      
      this.dataChartDate = response.data.date;
      this.dataChartTotal = response.data.total_share;  
    });
  }

}
